import * as React from 'react';
import ReactSelect from 'react-select'
import styled from 'styled-components';
import { Link } from 'components/Link'

const Wrapper = styled.div`
    width: 100%;
    margin-bottom: 20px;
`;

const Label = styled.div`
    color: #696E70;
    font-size: 16px;
    line-height: 22px;
    margin-bottom: 2px;
`;

const StyledReactSelect = styled(ReactSelect)`
    .react-select__control {
        border-radius: 20px;
        border-color: #B8C0C3;
        box-shadow: none;
        cursor: text;

        &:hover {
            border-color: #B8C0C3;
            box-shadow: none;
        }
    }
    .react-select__control--is-focused {
        border-color: #d5eae7 !important;
        box-shadow: 0 0 0 2px #d5eae7 !important;
    }
    .react-select__value-container {
        padding: 5px 16px;
    }
    .react-select__placeholder {
        font-size: 14px;
        color: #B8C0C3;
        font-weight: normal;
    }
    .react-select__single-value {
        font-size: 14px;
        font-weight: bold;
        color: #12191C;
    }
    .react-select__indicator-separator {
        display: none;
    }
    .react-select__indicator {
        padding-left: 0;
    }
    .react-select__option {
        font-size: 14px;
        color: #12191C;
    }
`;

const Asterisk = styled.span`
    display: inline-block;
    margin-left: 8px;
    color: #FF6060;
    font-weight: bold;
    font-size: 14px;
    position: relative;
    top: -2px;
`;

const Explanation = styled.div`
    font-size: 12px;
    border-radius: 100%;
    height: 20px;
    font-weight: bold;
    color: #333;
    padding: 2px 4px 0 6px;
    background: #EFEFEF;
    text-align: center;
    width: 20px;
    display: inline-block;
    margin-left: 10px;
`

export const Select = (props) => <Wrapper>
    <Label>
        {props.label}
        {props.required && <Asterisk>*</Asterisk>}
        {props.explanation &&
            <Link to={props.explanationLink}>
                <Explanation>
                    ?
                </Explanation>
            </Link>
        }
    </Label>
    <StyledReactSelect
        className="react-select__container"
        classNamePrefix="react-select"
        value={props.value}
        placeholder={props.placeholder || "Select..."}
        isClearable={props.isClearable || true}
        isMulti={props.isMulti || false}
        onChange={props.onChange}
        theme={(theme) => ({
            ...theme,
            colors: {
            ...theme.colors,
                primary25: '#EFEFEF',
                primary50: '#EFEFEF',
                primary75: '#d5eae7',
                primary: '#d5eae7',
            },
        })}
        options={props.options} />
</Wrapper>;
